@if (floatingLabel()) {
	<sim-labelled-container class="wrapper" [icon]="icon()" [label]="label()" [class.noBorder]="noBorder()">
		<ng-container [ngTemplateOutlet]="list" />
	</sim-labelled-container>
} @else {
	<div
		[class.noBorder]="noBorder()"
		class="wrapper styledContainer"
		cdkDropList
		cdkDropListSortingDisabled
		(cdkDropListDropped)="drop.emit($event)"
	>
		<label [class.floatingLabel]="floatingLabel()" class="headerLabel secondary">
			<mat-icon [fontIcon]="icon()" fontSet="fad" inline />
			{{ label() | translate }}
			@if (counter() !== null) {
				<span class="itemCount secondary">{{ counter() }}</span>
			}
			<div class="labelSuffix">
				<ng-content select="[labelSuffix]" />
			</div>
		</label>

		<ng-container [ngTemplateOutlet]="list" />
	</div>
}

<!--TEMPLATE-->
<ng-template #list>
	<div class="actions hideEmpty">
		<ng-content select="[actions]" />
	</div>

	<mat-divider />

	<div class="scrollViewport" [ngStyle]="{gap: gap()}">
		<ng-content />
	</div>
	<div class="emptyState hideEmpty secondary">
		<ng-content select="[emptyState]" />
	</div>
</ng-template>
